<ambita-cadastre-report-owners>
  <div class="ambita-cadastre-report__section ambita-cadastre-report__owners" id="ambita-cadastre-report__owners"
       if="{ isOwnersSectionVisible }">
    <h4 class="ambita-cadastre-report__section-title ambita-report-h4">{ i18n.propertyLookup.titleOwners }</h4>
    <table class="ambita-cadastre-report__list">
      <thead class="ambita-cadastre-report__header">
      <tr class="ambita-cadastre-report__row">
        <th>{ i18n.propertyLookup.ownerId }</th>
        <th>{ i18n.propertyLookup.ownerDate }</th>
        <th>{ i18n.propertyLookup.ownerName }</th>
        <th>{ i18n.propertyLookup.ownerFraction }</th>
        <th>{ i18n.propertyLookup.ownerAddress }</th>
        <th>{ i18n.propertyLookup.ownerRole }</th>
      </tr>
      </thead>
      <tbody data-is="ambita-cadastre-report-owners-subsection" owners="{ getMainCadastreOwners() }"></tbody>
      <tbody data-is="ambita-cadastre-report-owners-subsection" owners="{ getOwners() }"></tbody>
      <tbody data-is="ambita-cadastre-report-owners-subsection"
             owners="{ getMainCadastreUnregisteredOwnerships() }"></tbody>
      <tbody data-is="ambita-cadastre-report-owners-subsection" owners="{ getUnregisteredOwnerships() }"></tbody>
    </table>
  </div>

  <script>
    import './subsections/ownersSubsection.tag';
    import { init } from './sectionController';

    init(this);
  </script>
</ambita-cadastre-report-owners>
